// Uhome-AcCouple 参数设置页
// AcCouple 与单相 Uhome 共享同一套 Modbus 寄存器定义 (Uhome-AcCouple_V2.00.33.sql 已入库),
// 设置项完全由 bms.inverter_setting_def 数据驱动, 因此复用单相 Uhome 的分类折叠渲染逻辑。
// 后续若 AcCouple 有专属编辑项, 在此拆分即可。
import UhomeSinglePhaseSetting from './UhomeSinglePhaseSetting';

export default function UhomeAcCoupleSetting(props) {
    return <UhomeSinglePhaseSetting {...props} />;
}
